const resources = {

    
        "en": {
            "translation": {
                "Product Images": "Product Images",
                "Name :": "Name :",
                "Brands :": "Brands :",
                "Category :": "Category :",
                "Sub Category :": "Sub Category :",
                "Price :": "Price :",
                "Quantity :": "Quantity :",
                "Description :": "Description :",
                "Specification :": "Specification :",
                "Product Management Edit": "Product Management Edit",
                "Click to upload image": "Click to upload image",
                "handleRemoveImage(index)}>X": "handleRemoveImage(index)}>X",
                "{label}:": "{label}:",
                "Category Name": "Category Name",
                "Sub Category Name": "Sub Category Name",
                "Description:": "Description:",
                "Specification:": "Specification:",
                "Product Management Add": "Product Management Add",
                "Product Management": "Product Management",
                "S.No.": "S.No.",
                "Image": "Image",
                "Name": "Name",
                "Brand": "Brand",
                "Category": "Category",
                "Sub-Category": "Sub-Category",
                "Price": "Price",
                "Promote": "Promote",
                "Action": "Action",
                "Orders Management": "Orders Management",
                "Product": "Product",
                "Buyer": "Buyer",
                "Quantity": "Quantity",
                "Address": "Address",
                "Amount": "Amount",
                "Status": "Status",
                "{Type} Management": "{Type} Management",
                "Product Details": "Product Details",
                "product Image": "product Image",
                "User Details": "User Details",
                "Mobile No.": "Mobile No.",
                "Email": "Email",
                "Active": "Active",
                "Address Details": "Address Details",
                "Address :": "Address :",
                "Individual User Details": "Individual User Details",
                "No Plan": "No Plan",
                "Silver Plan": "Silver Plan",
                "Sr.No.": "Sr.No.",
                "Transaction Id": "Transaction Id",
                "Cutomer Name": "Cutomer Name",
                "Date and Time": "Date and Time",
                "User Company Details": "User Company Details",
                "Load/Unload Price": "Load/Unload Price",
                "Base KMs": "Base KMs",
                "Base Price": "Base Price",
                "Price Per Kilometer (PPK)": "Price Per Kilometer (PPK)",
                "Log Commission": "Log Commission",
                "Staff Member Management": "Staff Member Management",
                "Gender": "Gender",
                "Staff Member Details": "Staff Member Details",
                "Access & Permissions": "Access & Permissions",
                "Content Add": "Content Add",
                "Content Title": "Content Title",
                "Content Description": "Content Description",
                "Edit": "Edit",
                "Content Management": "Content Management",
                "CONTENT SECTION": "CONTENT SECTION",
                "Street": "Street",
                "City": "City",
                "State/Province": "State/Province",
                "Country": "Country",
                "Postal Code": "Postal Code",
                "Subscription Plan Management": "Subscription Plan Management",
                "Subscription Name": "Subscription Name",
                "Subscription Price": "Subscription Price",
                "Created At": "Created At",
                "Total Users": "Total Users",
                "40": "40",
                "Total Drivers": "Total Drivers",
                "100": "100",
                "Total Vehicles": "Total Vehicles",
                "20": "20",
                "Active Deals": "Active Deals",
                "60": "60",
                "Total Product &amp; Services": "Total Product & Services",
                "Total Revenue Generated": "Total Revenue Generated",
                "Total Commission Earned": "Total Commission Earned",
                "Total Completed Orders": "Total Completed Orders",
                "Recent Drivers": "Recent Drivers",
                "Top Product": "Top Product",
                "Total Product Growth": "Total Product Growth",
                "Recent Orders": "Recent Orders",
                "User": "User",
                "Falcon Admin": "Falcon Admin",
                "Dashboard": "Dashboard",
                "User Management": "User Management",
                "Driver Management": "Driver Management",
                "Category Management": "Category Management",
                "Comission Management": "Comission Management",
                "Document Request Management": "Document Request Management",
                "Chemical Tender Management": "Chemical Tender Management",
                "Transaction Management": "Transaction Management",
                "Help & Support Management": "Help & Support Management",
                "Order ID": "Order ID",
                "Username": "Username",
                "Date": "Date",
                "Transaction ID": "Transaction ID",
                "Payment Method": "Payment Method",
                "Description": "Description",
                "Category Details": "Category Details",
                "Category Name :": "Category Name :",
                "Sub Category Name :": "Sub Category Name :",
                "Status :": "Status :",
                "Created At :": "Created At :",
                "Chemical Tender Details": "Chemical Tender Details",
                "Chemical Name": "Chemical Name",
                "Title": "Title",
                "Documnet Request Management": "Documnet Request Management",
                "Document": "Document",
                "UserName": "UserName",
                "User Email": "User Email",
                "User Mobile no.": "User Mobile no.",
                "Documnet Request Details": "Documnet Request Details",
                "XYZ": "XYZ",
                "Jon Doe": "Jon Doe",
                "Jon@gmail.com": "Jon@gmail.com",
                "0000-0000-00": "0000-0000-00",
                "Help & Support": "Help & Support",
                "User NAME": "User NAME",
                "Query Title": "Query Title",
                "Help &amp; Support": "Help &amp; Support",
                "Update Status": "Update Status",
                "Add Reply": "Add Reply",
                "update": "update"
            }
        },
        "ar": {
            "translation": {
                "Product Images": "صور المنتج",
                "Name :": "اسم :",
                "Brands :": "العلامات التجارية:",
                "Category :": "فئة :",
                "Sub Category :": "الفئة الفرعية:",
                "Price :": "سعر :",
                "Quantity :": "كمية :",
                "Description :": "وصف :",
                "Specification :": "المواصفات:",
                "Product Management Edit": "إدارة المنتج تحرير",
                "Click to upload image": "انقر لتحميل الصورة",
                "handleRemoveImage(index)}>X": "HandlerMoveImage (الفهرس)}> x",
                "{label}:": "{ملصق}:",
                "Category Name": "اسم الفئة",
                "Sub Category Name": "اسم الفئة الفرعية",
                "Description:": "وصف:",
                "Specification:": "مواصفة:",
                "Product Management Add": "إدارة المنتج إضافة",
                "Product Management": "إدارة المنتج",
                "S.No.": "س.",
                "Image": "صورة",
                "Name": "اسم",
                "Brand": "ماركة",
                "Category": "فئة",
                "Sub-Category": "الفئة الفرعية",
                "Price": "سعر",
                "Promote": "يرقي",
                "Action": "فعل",
                "Orders Management": "إدارة أوامر",
                "Product": "منتج",
                "Buyer": "المشتري",
                "Quantity": "كمية",
                "Address": "عنوان",
                "Amount": "كمية",
                "Status": "حالة",
                "{Type} Management": "{type} الإدارة",
                "Product Details": "تفاصيل المنتج",
                "product Image": "صورة المنتج",
                "User Details": "تفاصيل المستخدم",
                "Mobile No.": "رقم الهاتف المحمول",
                "Email": "بريد إلكتروني",
                "Active": "نشيط",
                "Address Details": "تفاصيل العنوان",
                "Address :": "عنوان :",
                "Individual User Details": "تفاصيل المستخدم الفردية",
                "No Plan": "لا خطة",
                "Silver Plan": "خطة الفضة",
                "Sr.No.": "الأب",
                "Transaction Id": "معرف المعاملة",
                "Cutomer Name": "اسم Cutomer",
                "Date and Time": "التاريخ والوقت",
                "User Company Details": "تفاصيل شركة المستخدم",
                "Load/Unload Price": "تحميل/تفريغ سعر",
                "Base KMs": "قاعدة KMS",
                "Base Price": "سعر الأساس",
                "Price Per Kilometer (PPK)": "السعر لكل كيلومتر (PPK)",
                "Log Commission": "لجنة السجل",
                "Staff Member Management": "إدارة الموظفين",
                "Gender": "جنس",
                "Staff Member Details": "تفاصيل الموظفين",
                "Access & Permissions": "الوصول والأذونات",
                "Content Add": "إضافة المحتوى",
                "Content Title": "عنوان المحتوى",
                "Content Description": "وصف المحتوى",
                "Edit": "يحرر",
                "Content Management": "إدارة المحتوى",
                "CONTENT SECTION": "قسم المحتوى",
                "Street": "شارع",
                "City": "مدينة",
                "State/Province": "الدولة/المقاطعة",
                "Country": "دولة",
                "Postal Code": "رمز بريدي",
                "Subscription Plan Management": "إدارة خطة الاشتراك",
                "Subscription Name": "اسم الاشتراك",
                "Subscription Price": "سعر الاشتراك",
                "Created At": "تم إنشاؤها في",
                "Total Users": "إجمالي المستخدمين",
                "40": "40",
                "Total Drivers": "إجمالي السائقين",
                "100": "100",
                "Total Vehicles": "إجمالي المركبات",
                "20": "20",
                "Active Deals": "صفقات نشطة",
                "60": "60",
                "Total Product &amp; Services": "إجمالي المنتج & amp ؛ خدمات",
                "Total Revenue Generated": "إجمالي الإيرادات المولدة",
                "Total Commission Earned": "إجمالي العمولة المكتسبة",
                "Total Completed Orders": "إجمالي الطلبات المكتملة",
                "Recent Drivers": "برامج تشغيل حديثة",
                "Top Product": "أعلى المنتج",
                "Total Product Growth": "إجمالي نمو المنتج",
                "Recent Orders": "الطلبات الحديثة",
                "User": "مستخدم",
                "Falcon Admin": "مسؤول فالكون",
                "Dashboard": "لوحة القيادة",
                "User Management": "إدارة المستخدم",
                "Driver Management": "إدارة السائق",
                "Category Management": "إدارة الفئات",
                "Comission Management": "إدارة Comission",
                "Document Request Management": "إدارة طلب المستندات",
                "Chemical Tender Management": "إدارة العطاء الكيميائي",
                "Transaction Management": "إدارة المعاملات",
                "Help & Support Management": "إدارة المساعدة ودعم",
                "Order ID": "معرف الطلب",
                "Username": "اسم المستخدم",
                "Date": "تاريخ",
                "Transaction ID": "معرف المعاملة",
                "Payment Method": "طريقة الدفع",
                "Description": "وصف",
                "Category Details": "تفاصيل الفئة",
                "Category Name :": "اسم الفئة:",
                "Sub Category Name :": "اسم الفئة الفرعية:",
                "Status :": "حالة :",
                "Created At :": "تم إنشاؤها في:",
                "Chemical Tender Details": "تفاصيل العطاء الكيميائي",
                "Chemical Name": "الاسم الكيميائي",
                "Title": "عنوان",
                "Documnet Request Management": "إدارة طلب Documnet",
                "Document": "وثيقة",
                "UserName": "اسم المستخدم",
                "User Email": "البريد الإلكتروني للمستخدم",
                "User Mobile no.": "مستخدم الهاتف المحمول لا.",
                "Documnet Request Details": "تفاصيل طلب Documnet",
                "XYZ": "XYZ",
                "Jon Doe": "جون دو",
                "Jon@gmail.com": "jon@gmail.com",
                "0000-0000-00": "0000-0000-00",
                "Help & Support": "المساعدة والدعم",
                "User NAME": "اسم المستخدم",
                "Query Title": "عنوان الاستعلام",
                "Help &amp; Support": "مساعدة & amp ؛ يدعم",
                "Update Status": "حالة التحديث",
                "Add Reply": "أضف الرد",
                "update": "تحديث"
            }
        },
        "bn": {
            "translation": {
                "Product Images": "পণ্য চিত্র",
                "Name :": "নাম:",
                "Brands :": "ব্র্যান্ড:",
                "Category :": "বিভাগ:",
                "Sub Category :": "সাব বিভাগ:",
                "Price :": "মূল্য:",
                "Quantity :": "পরিমাণ:",
                "Description :": "বর্ণনা:",
                "Specification :": "স্পেসিফিকেশন:",
                "Product Management Edit": "পণ্য পরিচালনা সম্পাদনা",
                "Click to upload image": "চিত্র আপলোড করতে ক্লিক করুন",
                "handleRemoveImage(index)}>X": "হ্যান্ডলারমোভিমেজ (সূচক)}> x",
                "{label}:": "{লেবেল}:",
                "Category Name": "বিভাগের নাম",
                "Sub Category Name": "সাব বিভাগের নাম",
                "Description:": "বর্ণনা:",
                "Specification:": "স্পেসিফিকেশন:",
                "Product Management Add": "পণ্য পরিচালনা অ্যাড",
                "Product Management": "পণ্য পরিচালনা",
                "S.No.": "S.no.",
                "Image": "চিত্র",
                "Name": "নাম",
                "Brand": "ব্র্যান্ড",
                "Category": "বিভাগ",
                "Sub-Category": "উপ-বিভাগ",
                "Price": "দাম",
                "Promote": "প্রচার",
                "Action": "ক্রিয়া",
                "Orders Management": "অর্ডার পরিচালনা",
                "Product": "পণ্য",
                "Buyer": "ক্রেতা",
                "Quantity": "পরিমাণ",
                "Address": "ঠিকানা",
                "Amount": "পরিমাণ",
                "Status": "স্থিতি",
                "{Type} Management": "{টাইপ} পরিচালনা",
                "Product Details": "পণ্যের বিবরণ",
                "product Image": "পণ্য চিত্র",
                "User Details": "ব্যবহারকারীর বিশদ",
                "Mobile No.": "মোবাইল নং",
                "Email": "ইমেল",
                "Active": "সক্রিয়",
                "Address Details": "ঠিকানা বিশদ",
                "Address :": "ঠিকানা:",
                "Individual User Details": "স্বতন্ত্র ব্যবহারকারীর বিশদ",
                "No Plan": "কোন পরিকল্পনা নেই",
                "Silver Plan": "রৌপ্য পরিকল্পনা",
                "Sr.No.": "সিনিয়র এনও।",
                "Transaction Id": "লেনদেন আইডি",
                "Cutomer Name": "কাটোমারের নাম",
                "Date and Time": "তারিখ এবং সময়",
                "User Company Details": "ব্যবহারকারী সংস্থার বিশদ",
                "Load/Unload Price": "লোড/আনলোড দাম",
                "Base KMs": "বেস কেএমএস",
                "Base Price": "মূল মূল্য",
                "Price Per Kilometer (PPK)": "প্রতি কিলোমিটার দাম (পিপিকে)",
                "Log Commission": "লগ কমিশন",
                "Staff Member Management": "স্টাফ সদস্য পরিচালনা",
                "Gender": "লিঙ্গ",
                "Staff Member Details": "স্টাফ সদস্যের বিবরণ",
                "Access & Permissions": "অ্যাক্সেস এবং অনুমতি",
                "Content Add": "সামগ্রী যোগ করুন",
                "Content Title": "বিষয়বস্তু শিরোনাম",
                "Content Description": "বিষয়বস্তু বিবরণ",
                "Edit": "সম্পাদনা",
                "Content Management": "বিষয়বস্তু পরিচালনা",
                "CONTENT SECTION": "বিষয়বস্তু বিভাগ",
                "Street": "রাস্তা",
                "City": "শহর",
                "State/Province": "রাজ্য/প্রদেশ",
                "Country": "দেশ",
                "Postal Code": "ডাক কোড",
                "Subscription Plan Management": "সাবস্ক্রিপশন প্ল্যান ম্যানেজমেন্ট",
                "Subscription Name": "সাবস্ক্রিপশন নাম",
                "Subscription Price": "সাবস্ক্রিপশন মূল্য",
                "Created At": "এটি তৈরি",
                "Total Users": "মোট ব্যবহারকারী",
                "40": "40",
                "Total Drivers": "মোট ড্রাইভার",
                "100": "100",
                "Total Vehicles": "মোট যানবাহন",
                "20": "20",
                "Active Deals": "সক্রিয় ডিল",
                "60": "60",
                "Total Product &amp; Services": "মোট পণ্য & amp; পরিষেবাদি",
                "Total Revenue Generated": "মোট উপার্জন উত্পন্ন",
                "Total Commission Earned": "মোট কমিশন উপার্জন",
                "Total Completed Orders": "মোট সম্পূর্ণ আদেশ",
                "Recent Drivers": "সাম্প্রতিক ড্রাইভার",
                "Top Product": "শীর্ষ পণ্য",
                "Total Product Growth": "মোট পণ্য বৃদ্ধি",
                "Recent Orders": "সাম্প্রতিক আদেশ",
                "User": "ব্যবহারকারী",
                "Falcon Admin": "ফ্যালকন অ্যাডমিন",
                "Dashboard": "ড্যাশবোর্ড",
                "User Management": "ব্যবহারকারী পরিচালনা",
                "Driver Management": "ড্রাইভার ম্যানেজমেন্ট",
                "Category Management": "বিভাগ পরিচালনা",
                "Comission Management": "কমিশন ম্যানেজমেন্ট",
                "Document Request Management": "ডকুমেন্ট অনুরোধ পরিচালনা",
                "Chemical Tender Management": "রাসায়নিক টেন্ডার ম্যানেজমেন্ট",
                "Transaction Management": "লেনদেন ব্যবস্থাপনা",
                "Help & Support Management": "সহায়তা ও সহায়তা পরিচালনা",
                "Order ID": "অর্ডার আইডি",
                "Username": "ব্যবহারকারীর নাম",
                "Date": "তারিখ",
                "Transaction ID": "লেনদেন আইডি",
                "Payment Method": "অর্থ প্রদানের পদ্ধতি",
                "Description": "বর্ণনা",
                "Category Details": "বিভাগের বিশদ",
                "Category Name :": "বিভাগের নাম:",
                "Sub Category Name :": "সাব বিভাগের নাম:",
                "Status :": "স্থিতি:",
                "Created At :": "তৈরি:",
                "Chemical Tender Details": "রাসায়নিক টেন্ডার বিশদ",
                "Chemical Name": "রাসায়নিক নাম",
                "Title": "শিরোনাম",
                "Documnet Request Management": "ডকুমেন্টের অনুরোধ পরিচালনা",
                "Document": "নথি",
                "UserName": "ব্যবহারকারীর নাম",
                "User Email": "ব্যবহারকারী ইমেল",
                "User Mobile no.": "ব্যবহারকারী মোবাইল নং।",
                "Documnet Request Details": "ডকুমেন্টের অনুরোধের বিশদ",
                "XYZ": "Xyz",
                "Jon Doe": "জন ডো",
                "Jon@gmail.com": "Jon@gmail.com",
                "0000-0000-00": "0000-0000-00",
                "Help & Support": "সহায়তা এবং সমর্থন",
                "User NAME": "ব্যবহারকারীর নাম",
                "Query Title": "ক্যোয়ারী শিরোনাম",
                "Help &amp; Support": "সহায়তা & amp; সমর্থন",
                "Update Status": "আপডেট স্থিতি",
                "Add Reply": "উত্তর যোগ করুন",
                "update": "আপডেট"
            }
        }
    }


export default resources;